import { Colors, Helpers, Metrics, Spinner, Tab, Tabs, BREAK_POINTS } from '@origin-digital/style-guide';
import React from 'react';
import styled from 'styled-components';
import { CalculatorResultProps } from './CalculatorResult.types';
import { defaultRecommendations } from './defaultRecommendations';
import { ResultTab } from './ResultTab/ResultTab';

const Container = styled.div`
  position: relative;
  line-height: 24px;
  max-width: 540px;
  margin: auto;
  padding: ${Metrics.Spacing.P_Y_XS}px;
  box-sizing: border-box;
  display: none;

  &.loaded {
    display: block;
  }

  ${Helpers.media.MD`
    max-width: 600px;
  `}

  ${Helpers.media.LG`
    display: block;
    margin-left: ${Metrics.Spacing.M_X_LG}px;
    margin-right: 0;
    padding: 0;
    width: 600px;
  `}
  ${Helpers.media.XL`
    margin-left: ${Metrics.Spacing.M_X_LG}px;
    max-width: 60.5%;
    width: 60.5%;
  `}
`;

const Loading = styled.div`
  width: 100%;
  height: 100%;
  display: -ms-grid;
  display: grid;
  align-items: center;
  justify-content: center;

  &,
  &:before {
    position: absolute;
    top: 0;
    left: 0;
  }

  * {
    position: relative;
  }

  &:before {
    content: '';
    opacity: 0.8;
    left: ${Metrics.Spacing.M_Y_SM}px;
    right: ${Metrics.Spacing.M_Y_SM}px;
    top: ${Metrics.Spacing.M_Y_SM}px;
    bottom: ${Metrics.Spacing.M_Y_SM}px;
    background: ${Colors.WHITE};
  }

  ${Helpers.media.LG`
    &:before {
      top: 0;
    }
  `};
`;

export class CalculatorResult extends React.Component<CalculatorResultProps> {
  static defaultProps = {
    recommendations: defaultRecommendations,
    loaded: false
  };

  private scrollMarker: React.RefObject<HTMLSpanElement>;

  constructor(props: CalculatorResultProps) {
    super(props, {});
    this.scrollMarker = React.createRef();
  }

  render() {
    const { recommendations: result, loaded, values, onShowDisclaimer, calculationCount } = this.props;
    const { primaryRecommendationId, recommendations } = result;

    const activeTab = recommendations!.find(rec => rec!.id === primaryRecommendationId);

    const tabsKey = `${activeTab!.id}${calculationCount})`;

    return (
      <React.Fragment>
        <span style={{ visibility: 'hidden' }} ref={this.scrollMarker} />

        <Container className={loaded ? 'loaded' : ''}>
          <Tabs key={tabsKey} defaultActiveTab={activeTab!.id} flexMode="allMedia">
            {recommendations!.map(rec => {
              const solarSystemId: string = (rec && rec.solarSystem && rec.solarSystem.id) || '';
              const payoffYears: number = (rec && rec.solarSaving && rec.solarSaving.payoffTimeYears) || 0;
              const recommended = solarSystemId === primaryRecommendationId && payoffYears <= 10;
              return (
                <Tab key={rec!.id} id={rec!.id} title={rec!.solarSystem!.size}>
                  <ResultTab
                    recommendation={rec!}
                    recommended={recommended}
                    values={values}
                    onShowDisclaimer={onShowDisclaimer}
                  />
                </Tab>
              );
            })}
          </Tabs>
          {this.props.loading ? (
            <Loading>
              <Spinner size={48} />
            </Loading>
          ) : null}
        </Container>
      </React.Fragment>
    );
  }

  scrollTo() {
    if (window.innerWidth < parseInt(BREAK_POINTS.Min.LG)) {
      window.scroll(0, this.scrollMarker.current!.getBoundingClientRect().top);
    }
  }
}
